/**
 * Source of NBBO information.
 * tag: 2834
 * @readonly
 * @enum {number} (int)
 */
export enum NBBOSource {
  NotApplicable = 0,
  Direct = 1,
  SIP = 2,
  Hybrid = 3,
}
